import React from 'react';

export const GiftlistImage = (props) => {
  const {giftlistType, width} = props;

  return (
    <div className="giftlist-image-wrap">
      <img
        src={`/assets/images/giftlist/${giftlistType.toLowerCase()}.png`}
        alt="Amazon"
        width={width}
        className="giftlist-image"
      />
      <p className="fine-print">
        Powered by <img src="/assets/images/logos/amazon-logo-v2@2x.png" height="20" alt="Amazon" />
      </p>
    </div>
  );
};
